export default __webpack_public_path__ + "static/media/ref.b3386af9.png";